var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"X"},React.createElement("g",{"id":"Group"},React.createElement("g",{"id":"layer1"},React.createElement("path",{"id":"path1009","d":"M4.0584 5L13.3245 17.3895L4 27.4627H6.09874L14.2625 18.6432L20.8584 27.4627H28L18.2123 14.3765L26.8916 5H24.7929L17.2747 13.1223L11.2 5H4.0584ZM7.14469 6.54576H10.4255L24.9133 25.9169H21.6325L7.14469 6.54576Z","fill":"#AAB8D9"})))));
}

X.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = X;

X.default = X;
